import type { ReactNode } from 'react'
import React from 'react'

interface IPropTypes {
  children: ReactNode
}
export default function UILibraryLayout({ children }: IPropTypes) {
  return <div>{children}</div>
}
